module.exports = __webpack_public_path__ + "static/media/subICloud2.3961799e.png";